import React, {useEffect, useState} from 'react';
import {Form, Header, Message, Segment, Table} from 'semantic-ui-react';
import PutUsers, {EditUserRequest} from 'services/backoffice/users/put-users';
import GetUserById from 'services/backoffice/users/get-user';
import {useLoaderData, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import {changeBackofficeUserPassword} from "../../../../services/backoffice/users/backoffice-user-password";

export async function editUserLoader({params}: any) {
    return await GetUserById(params.id);
}

const EditBackofficeUserPage = () => {
    const [user, setUser] = useState<Partial<EditUserRequest>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const navigate = useNavigate();
    const loader: any = useLoaderData();
    useEffect(() => setUser(loader), [])

    const updateUser = async () => {
        try {
            setLoading(true);
            if (user) {
                const result = await PutUsers(user, user.id);
                if (result.success) navigate('/backoffice/users/')
                toast.success('Usuario atualizado com sucesso', ToasterConfig.success);
            }
            setLoading(false);
        } catch (error: any) {
            toast.warn('Falha ao atualizar usuario', ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    };

    const changePassword = async () => {
        if (!user?.id) return;

        if (password !== passwordConfirmation) {
            toast.warn('A senha e a confirmação devem ser iguais', ToasterConfig.error);
            return;
        }

        try {
            setLoading(true);
            const result = await changeBackofficeUserPassword(user.id, {
                password,
                passwordConfirmation,
            });
            toast.success(result.message, ToasterConfig.success);
            setPassword('');
            setPasswordConfirmation('');
        } catch (error: any) {
            const message = error?.response?.data?.errors?.[0]
                ?? error?.response?.data?.message
                ?? 'Falha ao alterar senha do usuário';
            toast.warn(message, ToasterConfig.error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Usuários do backoffice / Editar
            </Header>
            <Form size="large" onSubmit={updateUser}>
                <Segment stacked>
                    <Form.Input
                        fluid
                        label="Nome"
                        placeholder="Nome"
                        name="firstName"
                        value={user?.firstName}
                        onChange={(event) => setUser({...user, firstName: event.target.value})}
                        required
                    />
                    <Form.Input
                        fluid
                        label="Sobrenome"
                        placeholder="Sobrenome"
                        name="lastName"
                        value={user?.lastName}
                        onChange={(event) => setUser({...user, lastName: event.target.value})}
                        required
                    />
                    <Form.Input
                        fluid
                        label="E-mail"
                        placeholder="E-mail"
                        name="email"
                        value={user?.email}
                        onChange={(event) => setUser({...user, email: event.target.value})}
                        required
                        type="email"
                    />
                    <Table.Row>
                        <Table.HeaderCell>
                            <Form.Button content="Voltar"
                                         icon='arrow left'
                                         onClick={() => navigate('/backoffice/users/')} grey/>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <Form.Button content="Atualizar"
                                         type={"submit"}
                                         icon='save'
                                         color={"green"}/>
                        </Table.HeaderCell>
                    </Table.Row>
                    {error && <Message negative>{error}</Message>}
                </Segment>
            </Form>

            <Segment stacked>
                <Header as="h4" color="green">Alterar senha do usuário</Header>
                <Form>
                    <Form.Input
                        fluid
                        label="Nova senha"
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                    />
                    <Form.Input
                        fluid
                        label="Confirmação da senha"
                        type="password"
                        value={passwordConfirmation}
                        onChange={(event) => setPasswordConfirmation(event.target.value)}
                    />
                    <Form.Button
                        type="button"
                        color="orange"
                        icon="key"
                        content="Alterar senha"
                        onClick={changePassword}
                    />
                </Form>
            </Segment>
        </div>
    );
};

export default EditBackofficeUserPage;
